export var AgeGroup;
(function (AgeGroup) {
    AgeGroup["BABY"] = "baby";
    AgeGroup["TODDLER"] = "toddler";
    AgeGroup["CHILD"] = "child";
    AgeGroup["ADULT"] = "adult";
})(AgeGroup || (AgeGroup = {}));
export const getAgeGroup = (age) => {
    if (age < 365) {
        return AgeGroup.BABY;
    }
    else if (age < 1095) {
        return AgeGroup.TODDLER;
    }
    else if (age < 6570) {
        return AgeGroup.CHILD;
    }
    else {
        return AgeGroup.ADULT;
    }
};
//# sourceMappingURL=getAgeGroup.js.map